import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 43490 43353"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:485.782}.fil0{fill:#000}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        id="XMLID_290_"
        d="M22656 19721 35534 6614l-7745 4032-534-8715z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_522_"
        d="M36386 7450 23724 20337l17594-4868-8828-204z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_523_"
        d="M37248 5721z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_524_"
        d="M27137 1z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_356_"
        d="m41603 16500-18067 5133 18080 4674-7364-4691z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_526_"
        d="m41318 27463-17789-4599 13106 12877-4032-7744z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_527_"
        d="m22692 23717 4911 17705 380-8723 7815 3895z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_528_"
        d="m1539 26640 17434-4953-17549-4537 7364 4690z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_530_"
        d="m21500 19421 4599-17789-4691 7364-4821-7281z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_531_"
        d="M20384 23736 7507 36844l7745-4033 534 8715z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_532_"
        d="M27519 43352z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_533_"
        d="m21541 24035-4599 17790 4691-7365 4820 7281z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_534_"
        d="M43247 27345z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_535_"
        d="m6655 36007 13055-13287-17919 5090 8759 382z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_536_"
        d="m15437 2036-380 8723-7815-3896 13107 12877z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_537_"
        d="m6406 7716 4032 7744-8715 534 17788 4598z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_538_"
        d="M5513 6001z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
      <path
        id="XMLID_539_"
        d="M15521 105z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 485.782,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
